import type { MetricDefinition } from "../types";

/**
 * Case-insensitive substring filter over metric label, description, and id.
 * An empty/whitespace query returns the full list unchanged.
 */
export function filterMetricsByQuery(query: string, metrics: readonly MetricDefinition[]): MetricDefinition[] {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return [...metrics];

  return metrics.filter((metric) => {
    return (
      metric.label.toLowerCase().includes(normalized) ||
      metric.description.toLowerCase().includes(normalized) ||
      metric.id.toLowerCase().includes(normalized)
    );
  });
}
